import _regeneratorRuntime from '@babel/runtime/regenerator';
import { fork, call, take } from 'redux-saga/effects';

var takeUniqBy = function takeUniqBy(iteratee) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return takeUniqWith.apply(void 0, [function (a, b) {
    return Object.is(iteratee(a), iteratee(b));
  }].concat(rest));
};

var takeUniqWith = function takeUniqWith(comparator, patternOrChannel, saga) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    args[_key2 - 3] = arguments[_key2];
  }

  return fork( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var actions, _loop;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            actions = new Set();
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var action;
              return _regeneratorRuntime.wrap(function _loop$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      _context2.next = 2;
                      return take(patternOrChannel);

                    case 2:
                      action = _context2.sent;

                      if (Array.from(actions).some(function (a) {
                        return comparator(a, action);
                      })) {
                        _context2.next = 6;
                        break;
                      }

                      _context2.next = 6;
                      return fork( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                        return _regeneratorRuntime.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                actions.add(action);
                                _context.next = 3;
                                return call.apply(void 0, [saga].concat(args, [action]));

                              case 3:
                                actions["delete"](action);

                              case 4:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee);
                      }));

                    case 6:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _loop);
            });

          case 2:

            return _context3.delegateYield(_loop(), "t0", 4);

          case 4:
            _context3.next = 2;
            break;

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));
};

export { takeUniqBy, takeUniqWith };
//# sourceMappingURL=browser.esm.js.map
